// 圆形加号——主流程
const MainRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `icon/return/index${i + 1}`,
  name: `icon/returnIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/return/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 圆形加号——主流程，开始
    ...MainRoutes,
  ],
};
